export default __webpack_public_path__ + "5ec2517191524fa6495c0ae82a6cf494.png";